"use strict";

var _defineProperty = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/defineProperty.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PoolGraphUtils = void 0;
const common_sdk_1 = require("@orca-so/common-sdk");
class PoolGraphUtils {
  static getSearchPathId(tokenA, tokenB) {
    return "".concat(common_sdk_1.AddressUtil.toString(tokenA)).concat(PoolGraphUtils.PATH_ID_DELIMITER).concat(common_sdk_1.AddressUtil.toString(tokenB));
  }
  static deconstructPathId(pathId) {
    const split = pathId.split(PoolGraphUtils.PATH_ID_DELIMITER);
    if (split.length !== 2) {
      throw new Error("Invalid path id: ".concat(pathId));
    }
    const [tokenA, tokenB] = split;
    return [tokenA, tokenB];
  }
}
_defineProperty(PoolGraphUtils, "PATH_ID_DELIMITER", "-");
exports.PoolGraphUtils = PoolGraphUtils;
//# sourceMappingURL=pool-graph-utils.js.map